export type Source = {
    name: string;
    kind: "shelter" | "breeder";
    dogs: number;
};

export const SOURCE_FALLBACK: Source[] = [
    { name: "Mike's Chance Animal Rescue", kind: "shelter", dogs: 7092 },
    { name: "God's Dogs Rescue", kind: "shelter", dogs: 3883 },
    { name: "Ruff Road Revival", kind: "shelter", dogs: 2204 },
    { name: "Dizzy Dog Animal Rescue", kind: "shelter", dogs: 2211 },
    { name: "Nala and Friends Dog Rescue", kind: "shelter", dogs: 1488 },
    { name: "Dallas Animal Services", kind: "shelter", dogs: 1428 },
    { name: "Jenni's Rescue Ranch", kind: "shelter", dogs: 1108 },
    { name: "Wilder Souls Rescue", kind: "shelter", dogs: 953 },
    { name: "Northeast Georgia Animal Shelter", kind: "shelter", dogs: 925 },
    { name: "Hoardin' Huskies", kind: "shelter", dogs: 906 },
    { name: "Brandywine Valley SPCA", kind: "shelter", dogs: 883 },
    { name: "El Paso Animal Services", kind: "shelter", dogs: 867 },
    { name: "Souls of Satos", kind: "shelter", dogs: 862 },
    { name: "Big Fluffy Dog Rescue", kind: "shelter", dogs: 822 },
    { name: "Toodles Goldendoodles", kind: "breeder", dogs: 42 },
    { name: "Soaring Golden Retrievers", kind: "breeder", dogs: 40 },
    { name: "Southern Meadows Doodles", kind: "breeder", dogs: 33 },
    { name: "Adirondack Labradoodles", kind: "breeder", dogs: 32 },
    { name: "Flying LL Aussies", kind: "breeder", dogs: 32 },
    { name: "Red Acres Poodles & Doodles", kind: "breeder", dogs: 32 },
    { name: "Florida Wrinkles", kind: "breeder", dogs: 31 },
    { name: "Highland Point Corgis", kind: "breeder", dogs: 24 },
];
